import { AccountInfo } from '@azure/msal-browser';
import { map } from 'lodash-es';

import { SecurityMatrixDto } from 'api';
import { ADUser } from 'library/models/ADUser';
import { Area } from 'library/models/Area';
import { TokenClaims } from 'library/models/TokenClaims';
import { User } from 'library/models/User';
import { EmptyTextData } from 'library/types';

export const isExternalUser = ({ isExternal }: User) => isExternal;
export const isSuperUser = ({ roles }: User) =>
	roles.find(({ name }) => name === 'SUPER_USER') !== undefined;
export const isCentralAdmin = ({ roles }: User) =>
	roles.find(({ name }) => name === 'CENTRAL_ADMIN') !== undefined;

export const mapToADUser = (account: AccountInfo | null): ADUser => {
	if (account !== null) {
		const idTokenClaims = account.idTokenClaims;

		if (idTokenClaims !== undefined) {
			const tokenClaims = idTokenClaims as unknown as TokenClaims;

			return {
				id: tokenClaims.claimuserid,
				mail: tokenClaims.claimusermail,
				name: tokenClaims.name,
			};
		}
	}

	throw new Error(
		`Unable to map active directory user from ${account?.username}.`
	);
};

const mapToArea = (areaDto: SecurityMatrixDto): Area =>
	({
		name: areaDto.name,
		permissions: areaDto.permissions,
	}) as Area;

export const mapToAreas = (areaDtos: Array<SecurityMatrixDto>): Array<Area> =>
	map(areaDtos, (areaDto) => mapToArea(areaDto));

export const mapToUploaderName = ({ customer, userId }: User) =>
	mapToUploaderNameSpecific(
		userId,
		customer?.customerName,
		customer?.customerNumber
	);

export const mapToUploaderNameSpecific = (
	userId: string,
	customerName: EmptyTextData,
	customerNumber: number | null | undefined
) =>
	customerNumber && customerName
		? `${customerName} (${customerNumber}), ${userId}`
		: userId;
